var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"backgroundClass":"background","foregroundClass":"foreground","stencil-component":"circle-stencil","src":this.$root.state.upload.img,"default-size":_vm.defaultSize,"stencil-props":{
			aspectRatio: 1/1,
			movable: true,
			resizable: true
		},"debounce":false},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }